"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SimpleStagedObject = _interopRequireDefault(require("redux-less/SimpleStagedObject"));

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var _constants = require("settings-ui-sdk/SmtpTokens/constants");

var properties = [{
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.CAMPAIGN_NAME,
  initialValue: ''
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.CREATE_CONTACT,
  initialValue: false
}, {
  type: _PropertyTypes.default.SIMPLE,
  key: _constants.CREATED_BY,
  initialValue: ''
}];
var CreateSmtpToken = new _SimpleStagedObject.default({
  stagedSelector: function stagedSelector(state) {
    return state.modules.marketing.email.staging.createSmtpToken;
  },
  namespace: 'email',
  objectType: 'CreateSmtpToken',
  properties: properties
});
var _default = CreateSmtpToken;
exports.default = _default;
module.exports = exports.default;